import type { OutlookPluginAdapter } from "../context/types";

export interface WebAdapterOptions {
  onOpenEmail?: (messageId: string, taskName?: string) => void;
}

/**
 * Web adapter for the Outlook plugin context.
 * Provides mock implementations for use outside of Office.js environment.
 */
export function createWebAdapter(options: WebAdapterOptions = {}): OutlookPluginAdapter {
  let mockMessageId: string | null = null;

  return {
    openEmail: async (messageId: string, taskName?: string): Promise<void> => {
      console.log("[Web Mode] Opening email:", messageId, taskName ? `(task: ${taskName})` : "");

      if (options.onOpenEmail) {
        options.onOpenEmail(messageId, taskName);
      }
    },

    getCurrentMessageId: (): string | null => {
      return mockMessageId;
    },

    getTargetMailbox: async (): Promise<string | null> => {
      // Web context doesn't have real shared mailbox info
      return null;
    },

    openUrl: (url: string): void => {
      // Open URL in new browser tab
      window.open(url, "_blank");
    },

    draftEmail: (to: string[], subject: string, body: string, attachments?: string[]): void => {
      console.log("[Web Mode] Would draft email:", { to, subject, body, attachments });
    },

    isContextReady: (): boolean => {
      // Web context is always ready
      return true;
    },

    isDevMode: (): boolean => {
      // Web context is always considered "dev mode" for Office.js purposes
      return true;
    },
  };
}
